var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { registerClass, classNames, subClass, defaultTheme, } from '@food/css-manager';
import { Icon, } from './icons';
export var Layouts;
(function (Layouts) {
    Layouts["SINGLE_ELEMENT"] = "SINGLE_ELEMENT";
    Layouts["SINGLE_ROW"] = "SINGLE_ROW";
    Layouts["SHOW_ALL"] = "SHOW_ALL";
})(Layouts || (Layouts = {}));
// Se trascino meno di così non lo considero scroll (su Layouts.SINGLE_ELEMENT)
var MIN_SCROLL = 10; // px
// style
var style = registerClass(function (t, sc) { return "\n\twidth: 100%;\n\toverflow: hidden;\n\tposition: relative;\n\tuser-select: none;\n\n\t> ." + sc('scroller') + " {\n\t\toverflow: hidden;\n\t\tdisplay: inline-block;\n\t\tmax-width: 100%;\n\n\t\t&." + sc('dragging') + " {\n\t\t\tcursor: move;\n\t\t}\n\t}\n\t> ." + sc('arrowLinner') + ",\n\t> ." + sc('arrowRinner') + " {\n\t\theight: 100%;\n\t\twidth: " + t.ratios.xl * 2 * t.font.baseSize + "px;\n\n\t\t> span {\n\t\t\tposition: absolute;\n\t\t\theight: 100%;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-items: center;\n\t\t\tcursor: pointer;\n\t\t\tbackground-clip: padding-box; // CHROME FIX?\n\n\t\t\t> img {\n\t\t\t\twidth: " + t.ratios.xl * 2 * t.font.baseSize + "px;\n\t\t\t\tmargin: " + t.ratios.xs * t.font.baseSize + "px;\n\t\t\t}\n\t\t}\n\t\t." + sc('arrow') + " {\n\t\t\tfont-size: " + t.ratios.xl * 2 * t.font.baseSize + "px;\n\t\t}\n\t}\n\t> ." + sc('arrowLinner') + " {\n\t\t> span {\n\t\t\tbackground-image: linear-gradient(\n\t\t\t\tto right,\n\t\t\t\t#fff,\n\t\t\t\trgba(255, 255, 255, 0)\n\t\t\t);\n\t\t}\n\t}\n\t> ." + sc('arrowRinner') + " {\n\t\t> span {\n\t\t\tbackground-image: linear-gradient(\n\t\t\t\tto left,\n\t\t\t\t#fff,\n\t\t\t\trgba(255, 255, 255, 0)\n\t\t\t);\n\t\t}\n\t}\n\n\t." + sc('list') + " {\n\t\tdisplay: inline-flex;\n\t\tflex-direction: row;\n\t\tflex-wrap: nowrap;\n\t}\n\t." + sc('slide') + " {\n\t\tflex-shrink: 0;\n\t\tflex-grow: 0;\n\t\tpadding-bottom: 0;\n\t\tdisplay: flex;\n\t}\n\t&." + sc('layout', 'SINGLE_ELEMENT') + " {\n\t\tdisplay: flex;\n\t\t> ." + sc('scroller') + " {\n\t\t\tflex: 1 1 auto;\n\t\t}\n\t\t> ." + sc('arrowLinner') + ",\n\t\t> ." + sc('arrowRinner') + " {\n\t\t\tflex: 0 0 auto;\n\t\t}\n\t\t> ." + sc('arrowLinner') + " {\n\t\t\tcolor: " + t.colors.grey.light + ";\n\t\t\t> span {\n\t\t\t\tcursor: default;\n\t\t\t}\n\t\t}\n\t\t." + sc('list') + " {\n\t\t\ttransition: margin-left .5s;\n\t\t}\n\t\t." + sc('slide') + " {\n\t\t\tjustify-content: center;\n\t\t}\n\t\t." + sc('dragging') + " {\n\t\t\t." + sc('list') + " {\n\t\t\t\ttransition: margin-left 0s;\n\t\t\t}\n\t\t}\n\t\t&." + sc('scrolled') + " {\n\t\t\t> ." + sc('arrowLinner') + " {\n\t\t\t\tcolor: inherit;\n\t\t\t\t> span {\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&." + sc('scrolled-to-end') + " {\n\t\t\t> ." + sc('arrowRinner') + " {\n\t\t\t\tcolor: " + t.colors.grey.light + ";\n\t\t\t\t> span {\n\t\t\t\t\tcursor: default;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&." + sc('layout', 'SINGLE_ROW') + " {\n\t\t> ." + sc('arrowLinner') + ",\n\t\t> ." + sc('arrowRinner') + " {\n\t\t\tposition: absolute;\n\t\t\tz-index: " + t.zIndexes.P1_SlightlyAbove + ";\n\t\t\ttop: 0;\n\t\t\t> span {\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-items: center;\n\t\t\t\tbackground-clip: padding-box; // CHROME FIX?\n\t\t\t}\n\t\t}\n\t\t> ." + sc('arrowLinner') + " {\n\t\t\tleft: 0;\n\t\t\tdisplay: none;\n\t\t\t> span {\n\t\t\t\tbackground-image: linear-gradient(\n\t\t\t\t\tto right,\n\t\t\t\t\t#fff,\n\t\t\t\t\trgba(255, 255, 255, 0)\n\t\t\t\t);\n\t\t\t}\n\t\t}\n\t\t> ." + sc('arrowRinner') + " {\n\t\t\tright: 0;\n\t\t\t> span {\n\t\t\t\tbackground-image: linear-gradient(\n\t\t\t\t\tto left,\n\t\t\t\t\t#fff,\n\t\t\t\t\trgba(255, 255, 255, 0)\n\t\t\t\t);\n\t\t\t}\n\t\t}\n\t\t&." + sc('scrolled') + " {\n\t\t\t> ." + sc('arrowLinner') + " {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t\t&." + sc('scrolled-to-end') + " {\n\t\t\t> ." + sc('arrowRinner') + " {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n\t&." + sc('layout', 'SHOW_ALL') + " {\n\t\theight: auto;\n\n\t\t." + sc('list') + " {\n\t\t\tflex-wrap: wrap;\n\t\t\t> * {\n\t\t\t\t// flex-shrink: 0;\n\t\t\t\t// flex-grow: 0;\n\t\n\t\t\t\tmargin: " + (t.ratios.l / 2) * t.font.baseSize + "px;\n\t\t\t}\n\t\t}\n\t\t&:before,\n\t\t&:after {\n\t\t\tcontent: '';\n\t\t\torder: 1;\n\t\t\twidth: " + t.ratios.xl * 10 * t.font.baseSize + "px;\n\t\t\theight: 0;\n\t\t}\n\t}\n"; });
// helpers
// rendere la funzione pura
var easeInOutQuart = function (time, from, distance, duration) {
    time = (time * 2) / duration;
    if (time < 1) {
        return (distance / 2) * time * time * time * time + from;
    }
    return (-distance / 2) * ((time -= 2) * time * time * time - 2) + from;
};
var startTime;
// component
var Slider = /** @class */ (function (_super) {
    __extends(Slider, _super);
    function Slider(props) {
        var _this = _super.call(this, props) || this;
        _this.scrolled = function () {
            var s = _this.getScroll();
            var maxScroll = _this.getMaxScroll();
            var isScrollable = (_this.listRef.current.clientWidth > _this.scrollerRef.current.clientWidth);
            // console.log(this.listRef.current.className, this.listRef.current.clientWidth, this.scrollerRef.current.className, this.scrollerRef.current.clientWidth, isScrollable);
            var status;
            if (s <= 0) {
                status = { isScrolled: false, isScrolledToEnd: false, isScrollable: isScrollable };
            }
            else if (s >= maxScroll - 10) {
                // HACK - purtroppo non sempre è esattamente maxScroll a fine corsa
                status = { isScrolled: true, isScrolledToEnd: true, isScrollable: isScrollable };
            }
            else {
                status = { isScrolled: true, isScrolledToEnd: false, isScrollable: isScrollable };
            }
            if (status.isScrolled !== _this.state.isScrolled || status.isScrolledToEnd !== _this.state.isScrolledToEnd || status.isScrollable !== _this.state.isScrollable) {
                _this.setState(status);
            }
        };
        _this.containerRef = React.createRef();
        _this.scrollerRef = React.createRef();
        _this.listRef = React.createRef();
        _this.nextRef = React.createRef();
        _this.prevRef = React.createRef();
        _this.state = {
            isScrolled: false,
            isScrolledToEnd: false,
            isScrollable: false
        };
        return _this;
    }
    Slider.captureClick = function (e) {
        e.stopPropagation(); // Stop the click from being propagated.
        e.preventDefault(); // Cancel default behavior (ex.: link click)
        Slider.clearCaptureClick();
        return false;
    };
    Slider.setCaptureClick = function () {
        if (Slider.clickCaptured) {
            return;
        }
        document.addEventListener('click', Slider.captureClick, true);
        Slider.clickCaptured = true;
    };
    Slider.clearCaptureClick = function () {
        if (!Slider.clickCaptured) {
            return;
        }
        document.removeEventListener('click', Slider.captureClick, true); // cleanup
        Slider.clickCaptured = null;
    };
    /**
     * Su Layouts.SINGLE_ROW ridimensionando o facendo altre variazioni
     * posso dover aggiornare status.isScrolledToEnd perché sia sincronizzato con il DOM.
     * Faccio quindi un aggiornamento su timer ed in questo modo supporto anche l'eventuale variazione dinamica.
     * Non dovrebbe essere pesante sule prestazioni perché il browser fa una cache delle misure che gestisco
     * e quindi se questa non varia non deve ricalcolarla. In aggiunta lo faccio solo ogni 300ms.
     */
    Slider.prototype.startScrolledCheck = function () {
        if (this.scrolledTimer) {
            return;
        }
        this.scrolledTimer = setInterval(this.scrolled.bind(this), 300);
    };
    Slider.prototype.stopScrolledCheck = function () {
        if (!this.scrolledTimer) {
            return;
        }
        clearInterval(this.scrolledTimer);
        delete this.scrolledTimer;
    };
    Slider.prototype.onLayoutChange = function (newValue, oldValue) {
        if (newValue === oldValue) {
            return;
        }
        var listChildren = (this.listRef.current
            ? Array.from(this.listRef.current.children)
            : []);
        // Mantengo lo scroll per quanto possibile
        var currectScroll = this.getScroll();
        // Tolgo il vecchio
        // - Listeners
        switch (oldValue) {
            case Layouts.SINGLE_ROW:
            case Layouts.SINGLE_ELEMENT:
                this.scrollerRef.current.removeEventListener('dragstart', function (e) {
                    e.preventDefault();
                });
                this.scrollerRef.current.removeEventListener('mousedown', this.startDrag.bind(this));
                this.scrollerRef.current.removeEventListener('touchstart', this.startDrag.bind(this));
                this.scrollerRef.current.removeEventListener('mouseup', this.endDrag.bind(this));
                this.scrollerRef.current.removeEventListener('touchend', this.endDrag.bind(this));
                document.removeEventListener('mousemove', this.moveDrag.bind(this));
                document.removeEventListener('touchmove', this.moveDrag.bind(this));
                break;
            case Layouts.SHOW_ALL:
                break;
        }
        // - Sizes
        switch (oldValue) {
            case Layouts.SINGLE_ROW:
                this.stopScrolledCheck();
                break;
            case Layouts.SINGLE_ELEMENT:
                this.listRef.current.style.width = null; // CHECK
                listChildren.forEach(function (e) { return (e.style.width = null); });
                break;
            case Layouts.SHOW_ALL:
                break;
        }
        // Metto il nuovo
        // - Listeners
        switch (newValue) {
            case Layouts.SINGLE_ROW:
            case Layouts.SINGLE_ELEMENT:
                this.scrollerRef.current.addEventListener('dragstart', function (e) {
                    e.preventDefault();
                });
                this.scrollerRef.current.addEventListener('mousedown', this.startDrag.bind(this));
                this.scrollerRef.current.addEventListener('touchstart', this.startDrag.bind(this));
                document.addEventListener('mousemove', this.moveDrag.bind(this));
                document.addEventListener('touchmove', this.moveDrag.bind(this));
                this.scrollerRef.current.addEventListener('mouseup', this.endDrag.bind(this));
                this.scrollerRef.current.addEventListener('touchend', this.endDrag.bind(this));
                break;
            case Layouts.SHOW_ALL:
                break;
        }
        // - Sizes
        switch (newValue) {
            case Layouts.SINGLE_ROW:
                this.startScrolledCheck();
                break;
            case Layouts.SINGLE_ELEMENT:
                this.listRef.current.style.width = 100 * listChildren.length + "%";
                var childWidth_1 = 100 / listChildren.length + "%";
                listChildren.forEach(function (e) { return (e.style.width = childWidth_1); });
                break;
            case Layouts.SHOW_ALL:
                break;
        }
        // Traduco lo scroll nel nuovo layout
        this.setScroll(currectScroll);
    };
    Slider.prototype.componentDidMount = function () {
        var newLayout = this.props.layout || Layouts.SINGLE_ROW;
        this.onLayoutChange(newLayout, undefined);
        if (this.props.carusel) {
            this.startCarusel();
        }
    };
    Slider.prototype.componentDidUpdate = function (prevProps) {
        var newLayout = this.props.layout || Layouts.SINGLE_ROW;
        var oldLayout = prevProps.layout || Layouts.SINGLE_ROW;
        if (newLayout !== oldLayout) {
            this.onLayoutChange(newLayout, oldLayout);
        }
        if (this.props.carusel !== prevProps.carusel) {
            if (this.props.carusel) {
                this.startCarusel();
            }
            else {
                this.clearCarusel();
            }
        }
        else if (this.props.caruselIntervalFactor !== prevProps.caruselIntervalFactor &&
            this.props.carusel) {
            this.clearCarusel();
            this.startCarusel();
        }
    };
    Slider.prototype.componentWillUnmount = function () {
        var oldLayout = this.props.layout || Layouts.SINGLE_ROW;
        this.onLayoutChange(undefined, oldLayout);
        // clear timer (se presente)
        if (this.smoothTimer) {
            clearInterval(this.smoothTimer);
            delete this.smoothTimer;
        }
        this.clearCarusel();
        Slider.clearCaptureClick();
        delete this.draggingStart;
        this.stopScrolledCheck();
    };
    Slider.prototype.startCarusel = function () {
        if (!this.caruselTimer) {
            var timingFactor = this.props.caruselIntervalFactor || 1;
            this.caruselTimer = setInterval(this.stepCarusel.bind(this), defaultTheme.timings.base * 5 * timingFactor);
        }
    };
    Slider.prototype.stepCarusel = function () {
        if (!this.containerRef.current) {
            return;
        }
        var pos = this.containerRef.current.getBoundingClientRect();
        if (!pos ||
            !pos.height ||
            !pos.width || // Gestisce i display:none e quando è ridotto a dimensioni nulle
            pos.top > window.innerHeight ||
            pos.bottom < 0 || // Verticalmente fuori schermo
            pos.left > window.innerWidth ||
            pos.right < 0) {
            // Orizzontalmente fuori schermo
            // Non è visibile quindi non scorro
            return;
        }
        if (this.state.isScrolledToEnd) {
            this.scrollSmooth(0);
        }
        else {
            this.scrollParent(1);
        }
    };
    Slider.prototype.clearCarusel = function () {
        // clear timer (se presente)
        if (this.caruselTimer) {
            clearInterval(this.caruselTimer);
            delete this.caruselTimer;
        }
    };
    Slider.prototype.getScroll = function () {
        var layout = this.props.layout || Layouts.SINGLE_ROW;
        switch (layout) {
            case Layouts.SINGLE_ROW:
                // Espresso in px
                return this.scrollerRef.current.scrollLeft;
            case Layouts.SINGLE_ELEMENT:
                // Espreso in % negativa (es. '-200%')
                return ((-this.scrollerRef.current.clientWidth *
                    parseFloat(this.listRef.current.style.marginLeft)) /
                    100);
            case Layouts.SHOW_ALL:
                // Non si applica
                return undefined; // CHECK
        }
    };
    // Per coerenza con i metodi sopra
    // Permette di astrarre anche lo scroll in altre direzioni
    Slider.prototype.getMaxScroll = function () {
        // IMPORTANT this.scroller.scrollWidth cala mano a mano che do un margin negativo a this.list
        return (this.listRef.current.scrollWidth - this.scrollerRef.current.clientWidth);
    };
    Slider.prototype.getPageWidth = function () {
        var layout = this.props.layout || Layouts.SINGLE_ROW;
        var scrollWidth = this.scrollerRef.current.clientWidth;
        if (layout === Layouts.SINGLE_ROW) {
            var scroll_1 = this.getScroll();
            var maxScroll = this.getMaxScroll();
            // Qui la comparsa della arrow è dinamica e va in sovrapposizione
            // Negli altri layout non è così
            if (scroll_1 > 0) {
                scrollWidth -= this.prevRef.current.clientWidth;
            }
            if (scroll_1 < maxScroll) {
                scrollWidth -= this.nextRef.current.clientWidth;
            }
        }
        return scrollWidth;
    };
    Slider.prototype.setScroll = function (pxValue) {
        var layout = this.props.layout || Layouts.SINGLE_ROW;
        pxValue = Math.min(Math.max(pxValue, 0), this.getMaxScroll());
        switch (layout) {
            case Layouts.SINGLE_ROW:
                // Espresso in px
                this.scrollerRef.current.scrollLeft = pxValue || 0;
                this.listRef.current.style.marginLeft = '0'; // Pulisco perché può servire su cambio
                break;
            case Layouts.SINGLE_ELEMENT:
                // Espreso in % negativa (es. '-200%')
                this.listRef.current.style.marginLeft = "-" + 100 *
                    Math.round((pxValue || 0) / this.scrollerRef.current.clientWidth) + "%";
                this.scrollerRef.current.scrollLeft = 0; // Pulisco perché può servire su cambio
                this.scrolled(); // Aggiorno isScrolled e isScrolledToEnd
                break;
            case Layouts.SHOW_ALL:
                // Non si applica
                this.listRef.current.style.marginLeft = '0'; // Pulisco perché può servire su cambio
                this.scrollerRef.current.scrollLeft = 0; // Pulisco perché può servire su cambio
                break;
        }
    };
    Slider.getPos = function (e) {
        var pointer = e;
        if (e.touches && e.touches[0]) {
            return { x: e.touches[0].pageX, y: e.touches[0].pageY };
        }
        return { x: pointer.pageX, y: pointer.pageY };
    };
    Slider.prototype.startDrag = function (e) {
        this.draggingStart = this.draggingCur = Slider.getPos(e).x;
        this.scrolling = this.getScroll();
        this.scrollerRef.current.className += ' ' + subClass(style, 'dragging');
        this.clearCarusel();
    };
    // funzione che viene richiamata ad ogni movimento di muose/touch una volta che si e' in modalita' drag
    Slider.prototype.moveDrag = function (e) {
        if (!this.draggingStart) {
            return;
        }
        var pos = Slider.getPos(e);
        // IMPORTANT - Lo annoto perché su endDrag(..) devo usarlo in quanto event.touches poi non è più impostato e event.pageX è sempre a zero
        this.draggingCur = pos.x;
        var threshold = 10;
        var diff = this.draggingStart - this.draggingCur;
        if (diff < threshold) {
            return;
        }
        Slider.setCaptureClick();
        if (pos.x < this.containerRef.current.offsetLeft ||
            pos.x >
                this.containerRef.current.offsetLeft +
                    this.containerRef.current.clientWidth ||
            pos.y < this.containerRef.current.offsetTop ||
            pos.y >
                this.containerRef.current.offsetTop +
                    this.containerRef.current.clientHeight) {
            this.endDrag();
            return;
        }
        if (this.props.layout !== Layouts.SINGLE_ELEMENT) {
            this.setScroll(this.scrolling + diff);
        }
    };
    Slider.prototype.endDrag = function () {
        // IMPORTANT - Non misuro la posizione qui perché event.touches non è più impostato e event.pageX è sempre a zero
        // find move/dir
        var move = this.draggingStart - this.draggingCur;
        var dir = move > 0 ? 1 : -1;
        // reset
        delete this.draggingCur;
        delete this.draggingStart;
        this.scrollerRef.current.className = (' ' +
            this.scrollerRef.current.className +
            ' ')
            .replace(' ' + subClass(style, 'dragging') + ' ', '')
            .trim();
        // IMPORTANT - Uso setTimeout(.., 0) perché l'evento onClick si scatena dopo questo e se resetto subito non lo cattura più
        setTimeout(function () {
            Slider.clearCaptureClick();
        }, 0);
        // reposition into step
        if (this.props.layout === Layouts.SINGLE_ELEMENT) {
            if (Math.abs(move) > MIN_SCROLL) {
                this.scrollParent(dir);
            }
        }
        else {
            var scroll_2 = this.getScroll();
            var s = this.roundToNearestSlide(scroll_2, dir);
            this.scrollSmooth(s);
        }
    };
    Slider.prototype.scrollSmooth = function (val) {
        var _this = this;
        var layout = this.props.layout || Layouts.SINGLE_ROW;
        if (layout === Layouts.SINGLE_ELEMENT) {
            this.setScroll(val);
        }
        else if (layout === Layouts.SINGLE_ROW) {
            var start_1 = this.getScroll();
            var distance_1 = val - start_1;
            var duration_1 = defaultTheme.timings.base;
            startTime = new Date().getTime();
            if (this.smoothTimer) {
                clearInterval(this.smoothTimer);
            }
            this.smoothTimer = setInterval(function () {
                var time = new Date().getTime() - startTime;
                var scroll = easeInOutQuart(time, start_1, distance_1, duration_1);
                if (time >= duration_1) {
                    clearInterval(_this.smoothTimer);
                }
                _this.setScroll(scroll);
            }, 1000 / 60); // 60 fps
        }
    };
    Slider.calcNearSide = function (child, dir) {
        return dir > 0 ? child.offsetLeft : child.offsetLeft + child.offsetWidth;
    };
    Slider.prototype.roundToNearestSlide = function (scroll, dir, minOneStep) {
        var layout = this.props.layout || Layouts.SINGLE_ROW;
        var list = this.listRef.current;
        var maxScroll = this.getMaxScroll();
        var initialS = dir > 0 ? this.getScroll() : maxScroll - this.getScroll();
        // console.log('Initial', dir, minOneStep);
        var listChildren = Array.from(list.children);
        // Prendo il limite del 'nearSide' del primo / ultimo child in modo che siano tutti relativi a quello
        var initialChild = listChildren[dir > 0 ? 0 : listChildren.length - 1];
        var initialOffset = Slider.calcNearSide(initialChild, dir);
        // La arrow che mi interessa è display:none quindi prendo l'altro che è visibile ed è largo uguale
        var nearArrowSize = initialS > 0
            ? (this.prevRef.current || this.nextRef.current).offsetWidth
            : 0;
        var s = dir > 0 ? scroll : maxScroll - scroll;
        // console.log('A', {dir, s});
        // Prende l'ultima non mostrata completamente
        for (var i = 0; i < listChildren.length; i++) {
            // A seconda di 'dir' vado avanti o a ritroso
            var child = listChildren[dir > 0 ? i : listChildren.length - 1 - i];
            var nearSideDiff = dir > 0
                ? Slider.calcNearSide(child, dir) - initialOffset
                : initialOffset - Slider.calcNearSide(child, dir);
            // Prendo il primo che non è completamente visualizzato però faccio almeno un passo (se richiesto)
            // console.log('B-pre', {dir, i, nearSideDiff, initialS, nearArrowSize});
            if (nearSideDiff + child.offsetWidth > s + nearArrowSize &&
                (!minOneStep || nearSideDiff > initialS + nearArrowSize + 10)) {
                // HACK - purtroppo, credo per problemi di arrtondamento, a volte i valori non tornano
                s = nearSideDiff;
                // console.log('B', {dir, i, s, initialS, nearArrowSize});
                break;
            }
        }
        if (layout === Layouts.SINGLE_ROW) {
            // Qui la comparsa della arrow è dinamica e va in sovrapposizione quindi devo adeguarmi
            if (s > 0) {
                // La arrow che mi interessa è display:none quindi prendo l'altro che è visibile ed è largo uguale
                s -=
                    dir > 0
                        ? this.nextRef.current.clientWidth
                        : this.prevRef.current.clientWidth;
                // console.log('C', {dir, s});
            }
        }
        s = dir > 0 ? s : maxScroll - s;
        // console.log('D', {dir, s});
        s = Math.max(0, Math.min(s, maxScroll));
        // console.log('E', {dir, s});
        return s;
    };
    Slider.prototype.scrollParent = function (dir) {
        var scroll = this.getScroll();
        // if (scroll > 0) {
        // 	scroll += this.prevRef.current.clientWidth;
        // }
        scroll += (dir > 0 ? 1 : -1) * this.getPageWidth();
        var s = this.roundToNearestSlide(scroll, dir, true); // Faccio il passo
        this.scrollSmooth(s);
    };
    Slider.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, children = _a.children, _b = _a.layout, layout = _b === void 0 ? Layouts.SINGLE_ROW : _b;
        var _c = this.state, isScrolled = _c.isScrolled, isScrolledToEnd = _c.isScrolledToEnd, isScrollable = _c.isScrollable;
        return (React.createElement("div", { className: classNames(style, className, subClass(style, 'scroller-container'), isScrolled && isScrollable ? subClass(style, 'scrolled') : null, isScrolledToEnd || !isScrollable ? subClass(style, 'scrolled-to-end') : null, subClass(style, 'layout', layout)), ref: this.containerRef },
            layout !== Layouts.SHOW_ALL && (React.createElement("div", { className: subClass(style, 'arrowLinner'), onClick: function () {
                    _this.clearCarusel();
                    _this.scrollParent(-1);
                }, ref: this.prevRef },
                React.createElement("span", null,
                    React.createElement(Icon, { className: subClass(style, 'arrow'), name: 'chevron_left' })))),
            React.createElement("div", { className: subClass(style, 'scroller'), onScroll: this.scrolled, ref: this.scrollerRef },
                React.createElement("div", { className: subClass(style, 'list'), ref: this.listRef }, children &&
                    children.map(function (item, i) { return (React.createElement("div", { className: subClass(style, 'slide'), key: i }, item)); }))),
            layout !== Layouts.SHOW_ALL && (React.createElement("div", { className: subClass(style, 'arrowRinner'), onClick: function () {
                    _this.clearCarusel();
                    _this.scrollParent(1);
                }, ref: this.nextRef },
                React.createElement("span", null,
                    React.createElement(Icon, { className: subClass(style, 'arrow'), name: 'chevron_right' }))))));
    };
    return Slider;
}(React.Component));
export { Slider };
//# sourceMappingURL=Slider.js.map